import { Component, computed, inject, input, InputSignal, output } from '@angular/core';
import { ProductCard } from '../../product-card/product-card.types';
import { handleImageError } from '../../common/utils';
import { CommonModule } from '@angular/common';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterLink } from '@angular/router';
import { OrderService } from '../../order.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-product-card-v2-cross-sell',
  imports: [
    CommonModule,
    NgbTooltipModule,
    RouterLink,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule
  ],
  templateUrl: './product-card-v2-cross-sell.component.html',
  styleUrl: './product-card-v2-cross-sell.component.scss'
})
export class ProductCardV2CrossSellComponent {

  //#region Services

  #orderService = inject(OrderService);

  //#endregion

  //#region I/O

  card = input.required<ProductCard>();

  selectedPackageId = input.required<number>();

  orderId = input.required<number>();

  odooOrder = computed(() => this.#orderService.odooOrder());

  productAttributes: InputSignal<Array<any>> = input.required();

  selectedAttribute: InputSignal<any> = input.required();

  selectedPackage: InputSignal<any> = input.required();

  selectedAttributeCardConfig: InputSignal<any> = input.required();

  outOnAttributeChange = output<{ id: number, event: any }>();

  outOnPackageChanged = output<any>();

  outAddProductToCart = output<{ isSubscription: boolean, event: any, isFromCrossSell: boolean }>();

  //#endregion

  //#region Constructors


  //#endregion

  //#region Methods

  handleImageError = handleImageError;

  //#endregion
}
